document.addEventListener("DOMContentLoaded", function () {

  // ─── In-memory cart cache ─────────────────────────────────────────────────────
  let cachedCart = null;

  // ─── Cart notification timer ──────────────────────────────────────────────────
  let cartNotifTimer = null;

  function getCartNotifEl() {
    return document.querySelector('.CartNotifaction-Sec');
  }

  function showCartNotification(autoHideMs = 3000) {
    const el = getCartNotifEl();
    if (!el) return;
    el.classList.add('active');
    if (cartNotifTimer) clearTimeout(cartNotifTimer);
    cartNotifTimer = setTimeout(() => el.classList.remove('active'), autoHideMs);
  }

  function hideCartNotification() {
    const el = getCartNotifEl();
    if (!el) return;
    el.classList.remove('active');
    if (cartNotifTimer) { clearTimeout(cartNotifTimer); cartNotifTimer = null; }
  }

  // ─── Helpers ──────────────────────────────────────────────────────────────────
  function formatINR(x) {
    return x.toLocaleString('en-IN');
  }

  function detectPageType() {
    const url = window.location.href.toLowerCase();
    if (url.includes("/products/"))   return "Product Page";
    if (url.includes("/collections/")) return "Collection Page";
    if (url.includes("/pages/"))       return "Static Page";
    if (url === "https://innovist.com" || url === "https://innovist.com/") return "Home Page";
    return "Other";
  }

  function filterCartItems(cart, config = {}) {
    if (!config.blacklistProducts)    config.blacklistProducts    = ["none"];
    if (!config.blacklistCollections) config.blacklistCollections = ["none"];
    return cart.items.filter(item => {
      const isBlacklistedProduct = config.blacklistProducts[0] !== "none" &&
        config.blacklistProducts.map(String).includes(String(item.product_id));
      const isBlacklistedCollection = config.blacklistCollections[0] !== "none" &&
        item.collection_ids &&
        item.collection_ids.some(cid =>
          config.blacklistCollections.map(String).includes(String(cid))
        );
      return !(isBlacklistedProduct || isBlacklistedCollection);
    });
  }

  function getFilteredCartTotalAndQty(cart, config = {}) {
    const filteredItems = filterCartItems(cart, config);
    let subTotal = 0, qty = 0;
    filteredItems.forEach(item => {
      subTotal += Number(item.final_line_price) / 100;
      qty += item.quantity;
    });
    return { subTotal, qty };
  }

function toggleCartBottomVisibility(cart) {
  document.querySelectorAll(".CartBottom-SectionMain").forEach(el => {
    if (cart.items.length > 0) {
      el.style.display = "flex";
      el.classList.add("active");
    } else {
      el.style.display = "none";
      el.classList.remove("active");
    }
  });
}
  // ─── Blacklist helper ─────────────────────────────────────────────────────────
  // Extracted outside setupAddToCartButtons so it's not re-declared on every click.
  function isVariantBlacklisted(cart, variantId, config = window.STICKY_CART_CONFIG) {
    if (!config.blacklistProducts)    config.blacklistProducts    = ["none"];
    if (!config.blacklistCollections) config.blacklistCollections = ["none"];
    const item = cart.items.find(i => i.variant_id == variantId);
    if (!item) return false;
    const byProduct = config.blacklistProducts[0] !== "none" &&
      config.blacklistProducts.map(String).includes(String(item.product_id));
    const byCollection = config.blacklistCollections[0] !== "none" &&
      item.collection_ids?.some(cid =>
        config.blacklistCollections.map(String).includes(String(cid))
      );
    return byProduct || byCollection;
  }

  // ─── Single cart-sync pipeline (INP fix) ──────────────────────────────────────
  // Previously every path (fetch interceptor, Sidecart message listener, ATC
  // reconcile, visibilitychange, initial load) fired its own GET /cart.js and
  // re-rendered the sticky bar + every product card. One cart mutation by any
  // app (Helium / Wishlink attribute writes on page load, Shiprocket, etc.)
  // fanned out into ~5 GET /cart.js + ~5 full re-renders from this file alone.
  //
  // Now:
  //  1. All reads go through requestCartSync(): calls within CART_SYNC_DEBOUNCE_MS
  //     are merged, and only one GET /cart.js is ever in flight.
  //  2. change/update/clear.js already return the full cart, so the interceptor
  //     renders from the response body instead of fetching /cart.js again.
  //  3. applyCart() skips DOM work when items/quantities/prices are unchanged
  //     (e.g. an app writing only cart *attributes*), and Shiprocket is only asked
  //     to recalculate when the items actually changed.
  const CART_SYNC_DEBOUNCE_MS = 150;
  let cartSyncTimer = null;
  let cartSyncInFlight = false;
  let cartSyncQueued = false;
  let cartSyncWaiters = [];
  let lastRenderedCartSig = null;

  // Other blocks on the page (e.g. the PDP sticky buy-buttons) subscribe here
  // instead of wrapping fetch / fetching /cart.js themselves.
  const cartSubscribers = [];
  let lastNotifiedCartSig = null;

  function notifyCartSubscribers(cart, sig) {
    if (sig === lastNotifiedCartSig) return;
    lastNotifiedCartSig = sig;
    cartSubscribers.slice().forEach(fn => {
      try { fn(cart); } catch (err) { console.error("cart subscriber failed:", err); }
    });
  }

  function cartSignature(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return (
      cart.item_count + "|" + cart.total_price + "|" +
      cart.items
        .map(i => i.key + ":" + i.quantity + ":" + i.final_line_price)
        .join(",")
    );
  }

  // Render a cart into the sticky bar / product cards. Returns true if it rendered.
  function applyCart(cart, { force = false } = {}) {
    const sig = cartSignature(cart);
    if (!sig) return false;

    cachedCart = cart;
    window.cachedCart = cart;

    if (CartLimits) CartLimits.record(cart);

    // Subscribers hear about every real change (items / qty / price), whether
    // or not this file needs to re-render its own UI.
    notifyCartSubscribers(cart, sig);

    if (!force && sig === lastRenderedCartSig) return false;

    updateStickyCartBarWithTiers(cart);
    lastRenderedCartSig = sig;

    // Shopify cart JSON does not contain the Sidecart discount. Keep the last
    // confirmed Sidecart payable amount visible after re-rendering totals.
    if (hasActiveSidecartDiscount()) {
      applySidecartDiscountTotals();
    }
    return true;
  }

  function requestCartSync() {
    return new Promise((resolve, reject) => {
      cartSyncWaiters.push({ resolve, reject });
      if (cartSyncTimer) clearTimeout(cartSyncTimer);
      cartSyncTimer = setTimeout(runCartSync, CART_SYNC_DEBOUNCE_MS);
    });
  }

  function runCartSync() {
    cartSyncTimer = null;
    if (cartSyncInFlight) {
      // A read is already on the wire; run exactly one more after it lands.
      cartSyncQueued = true;
      return;
    }

    const waiters = cartSyncWaiters;
    cartSyncWaiters = [];
    if (!waiters.length) return;
    cartSyncInFlight = true;

    fetch(`/cart.js?ts=${Date.now()}`, {
      method: "GET",
      cache: "no-store",
      headers: { "Cache-Control": "no-cache" },
    })
      .then(res => {
        if (!res.ok) throw new Error(`cart.js failed with status ${res.status}`);
        return res.json();
      })
      .then(cart => waiters.forEach(w => w.resolve(cart)))
      .catch(err => waiters.forEach(w => w.reject(err)))
      .finally(() => {
        cartSyncInFlight = false;
        if (cartSyncQueued || cartSyncWaiters.length) {
          cartSyncQueued = false;
          runCartSync();
        }
      });
  }

  // ─── Optimistic UI helpers ────────────────────────────────────────────────────
  // Called right after add.js resolves — instantly reflects the add in the UI.
  // The next cart sync overwrites these with confirmed server values.

  function optimisticallyUpdateBubble() {
    const bubbleEl  = document.querySelector(".cart-link__bubble")     || document.querySelector(".cart-link-bubble");
    const bubbleNum = document.querySelector(".cart-link__bubble-num") || document.querySelector(".cart-link-bubble-num");
    if (bubbleNum) {
      bubbleNum.textContent = (parseInt(bubbleNum.textContent, 10) || 0) + 1;
    }
    if (bubbleEl) bubbleEl.classList.add("cart-link__bubble--visible");
    // DOM no longer matches the last rendered cart → next sync must re-render.
    lastRenderedCartSig = null;
  }

  function hasActiveSidecartDiscount() {
    const details = window.sidecartDiscountDetails;

    return Boolean(
      details &&
      details.status === "applied" &&
      Number(details.discount) > 0 &&
      Number.isFinite(Number(details.to_pay_amount))
    );
  }

  function optimisticallyUpdateStickyBar(itemPriceInPaise) {
    const itemPrice = itemPriceInPaise / 100;

    // Bump item count label
    document.querySelectorAll(".item-count-layout").forEach(el => {
      const current  = parseFloat(el.textContent.replace(/,/g, "")) || 0;
      const newCount = current + 1;
      el.textContent = `${newCount} ${newCount === 1 ? "item" : "items"}`;
    });

    // Bump total only when no Sidecart discount is active.
    // When discounted, keep the last confirmed to_pay_amount visible until
    // Shiprocket recalculates and sends the new discounted payable amount.
    if (!hasActiveSidecartDiscount()) {
      document.querySelectorAll(".item-total-layout").forEach(el => {
        const current  = parseFloat(el.textContent.replace(/,/g, "")) || 0;
        el.textContent = formatINR(current + itemPrice);
      });
    }

    // Ensure sticky bar is visible on mobile (first-item-added case)
    document.querySelectorAll(".CartBottom-SectionMain").forEach(el => {
      if (window.innerWidth < 768) {
        el.style.display = "flex";
        el.classList.add("active");
      }
    });

    lastRenderedCartSig = null;
  }


  // ─── Product-card quantity selector ──────────────────────────────────────────
  // Each grid card can represent a different variant, so quantity state is kept
  // per variant instead of using one global PDP-style lineItemKey/serverQty pair.
  const productCardVariantState = new Map();

  function getVariantState(variantId) {
    const key = String(variantId || "");
    if (!productCardVariantState.has(key)) {
      productCardVariantState.set(key, {
        qty: 0,            // total units of this variant across ALL cart lines (display)
        lineItemKey: null, // the line "−" acts on
        lineQty: 0,        // that line's own quantity (a variant can span several lines)
        requesting: false,
        startedAt: null,
      });
    }
    return productCardVariantState.get(key);
  }

  // ─── Request safety helpers ───────────────────────────────────────────────────
  // /cart/*.js can hang (flaky mobile network, backgrounded tab, Shopify cart
  // throttling). Without a timeout the promise never settles, the loader spins
  // forever and state.requesting stays true, so the card is dead until reload.
  const PRODUCT_CARD_REQUEST_TIMEOUT_MS = 15000;

  function fetchWithTimeout(url, options = {}, timeoutMs = PRODUCT_CARD_REQUEST_TIMEOUT_MS) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    // __innovistOwn: tells the fetch interceptor this request is ours, so it
    // doesn't start a second sync for an add we already reconcile ourselves.
    // Unknown init keys are ignored by fetch() and passed through by wrappers.
    return fetch(url, { ...options, signal: controller.signal, __innovistOwn: true }).finally(() =>
      clearTimeout(timer)
    );
  }

  async function readCartError(res, fallback) {
    try {
      const body = await res.json();
      return body.description || body.message || fallback;
    } catch (_) {
      return fallback;
    }
  }

  let productCardToastTimer = null;

  function showProductCardError(message) {
    if (!message) return;

    let toast = document.querySelector(".product-card-cart-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "product-card-cart-toast";
      toast.setAttribute("role", "status");
      toast.style.cssText =
        "position:fixed;left:50%;bottom:90px;transform:translateX(-50%);" +
        "max-width:90vw;padding:10px 16px;border-radius:9999px;background:#111;" +
        "color:#fff;font-size:14px;line-height:1.3;text-align:center;z-index:2147483000;" +
        "box-shadow:0 4px 16px rgba(0,0,0,.2);pointer-events:none;";
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.style.display = "block";

    if (productCardToastTimer) clearTimeout(productCardToastTimer);
    productCardToastTimer = setTimeout(() => {
      toast.style.display = "none";
    }, 3500);
  }

  // ─── Cart limits (shared module: assets/cart-limits.js) ───────────────────────
  // All limit state lives in window.CartLimits so this file, the PDP buy block
  // and the network guard never keep separate counts. CartLimits is optional:
  // if cart-limits.js is missing, everything below is a no-op.
  const CartLimits = window.CartLimits || null;
  const CART_LIMIT_HEADERS = CartLimits ? { [CartLimits.HEADER]: "1" } : {};

  function getProductCardProductId(container) {
    if (!container) return null;
    const atcButton = getProductCardAtcButton(container);
    const productId =
      container.dataset.productId ||
      atcButton?.dataset.productId ||
      container.closest("[data-product-id]")?.dataset.productId ||
      null;
    if (productId && CartLimits) {
      CartLimits.registerVariant(getProductCardVariantId(container), productId);
    }
    return productId ? String(productId) : null;
  }

  async function reserveCartLimit(productId) {
    if (!CartLimits) return { ok: true };
    return CartLimits.reserve(productId, 1);
  }

  // Visual state only: class + aria-disabled, never `disabled`, because
  // setVariantLoading() owns `disabled`. Click handlers enforce the limits.
  // Batched to one run per frame so a burst of limit changes = one DOM pass.
  let cartLimitUiFrame = null;
  function applyCartLimitUi() {
    if (!CartLimits || cartLimitUiFrame) return;
    cartLimitUiFrame = requestAnimationFrame(() => {
      cartLimitUiFrame = null;
      const cartBlocked = CartLimits.isCartBlocked();

      document
        .querySelectorAll(".Addtocart_buttonsec, .Addtocart_ba-custom_buttonsec")
        .forEach(container => {
          const productBlocked = CartLimits.isProductBlocked(getProductCardProductId(container));
          const blocked = cartBlocked || productBlocked;
          container.classList.toggle("cart-limit-reached", cartBlocked);
          container.classList.toggle("product-limit-reached", productBlocked);

          const value = blocked ? "true" : "false";
          [container.querySelector(".increase-qty"), getProductCardAtcButton(container)]
            .forEach(btn => {
              if (btn && btn.getAttribute("aria-disabled") !== value) {
                btn.setAttribute("aria-disabled", value);
              }
            });
        });
    });
  }

  document.addEventListener("cart-limits:change", applyCartLimitUi);

  // Force every product card out of its loading state. Used when the page is
  // restored from bfcache or becomes visible again, where an interrupted
  // request may have left a card permanently spinning and disabled.
  function clearStaleProductCardLoading(maxAgeMs = 5000) {
    let clearedAny = false;

    productCardVariantState.forEach(state => {
      if (!state.requesting) return;
      if (state.startedAt && Date.now() - state.startedAt < maxAgeMs) return;
      state.requesting = false;
      state.startedAt = null;
      clearedAny = true;
    });

    if (!clearedAny) return;

    document
      .querySelectorAll(".Addtocart_buttonsec, .Addtocart_ba-custom_buttonsec")
      .forEach(container => {
        const loader = container.querySelector(".loadersec");
        const atcButton = getProductCardAtcButton(container);
        const buttonText = atcButton?.querySelector(".custom-button-text");
        const qtyUi = container.querySelector(".product-card-qty-ui");

        if (loader) loader.style.display = "none";
        if (atcButton) {
          atcButton.disabled = false;
          atcButton.classList.remove("adding");
        }
        if (buttonText) buttonText.style.visibility = "visible";
        if (qtyUi) {
          qtyUi.classList.remove("is-loading");
          qtyUi.querySelectorAll("button").forEach(b => {
            b.disabled = false;
          });
        }
      });
  }

  function getProductCardAtcButton(container) {
    if (!container) return null;
    return container.querySelector(
      'button[data-id]:not(.increase-qty):not(.decrease-qty)'
    );
  }

  function ensureProductCardQtyUi(container) {
    if (!container) return null;

    let qtyUi = container.querySelector(".product-card-qty-ui");

    if (!qtyUi) {
      qtyUi = document.createElement("div");
      qtyUi.className = "product-card-qty-ui";
      qtyUi.hidden = true;
      container.appendChild(qtyUi);
    }

    // Normalize the markup even when an older Liquid version already rendered
    // a selector. This prevents legacy ATC button CSS from affecting +/- cells.
    if (qtyUi.dataset.qtySelectorReady !== "true") {
      const existingQty =
        Number(qtyUi.querySelector("[data-qty-value], .qty")?.textContent) || 1;

      qtyUi.innerHTML = `
        <button class="decrease-qty" type="button" aria-label="Decrease quantity">&minus;</button>
        <span class="product-card-qty-center">
          <span class="qty" data-qty-value>${existingQty}</span>
          <span class="product-card-qty-loader" aria-hidden="true"></span>
        </span>
        <button class="increase-qty" type="button" aria-label="Increase quantity">+</button>
      `;
      qtyUi.dataset.qtySelectorReady = "true";
    }

    // Reuse the exact same loader markup already present in the card.
    const sourceLoader = container.querySelector(".loadersec");
    const centerLoader = qtyUi.querySelector(".product-card-qty-loader");
    if (centerLoader && !centerLoader.innerHTML.trim() && sourceLoader?.innerHTML.trim()) {
      centerLoader.innerHTML = sourceLoader.innerHTML;
    }

    return qtyUi;
  }

  function getProductCardVariantId(container) {
    if (!container) return "";

    if (container.dataset.variantId) {
      return String(container.dataset.variantId);
    }

    const atcButton = getProductCardAtcButton(container);
    const variantId = atcButton?.dataset.id || "";

    if (variantId) {
      container.dataset.variantId = variantId;
    }

    return String(variantId);
  }

  function renderProductCardQty(container, qty) {
    if (!container) return;

    const atcButton = getProductCardAtcButton(container);
    if (!atcButton) return;

    const qtyUi = ensureProductCardQtyUi(container);
    const qtyValue = qtyUi?.querySelector("[data-qty-value], .qty");
    const safeQty = Math.max(0, Number(qty) || 0);

    if (qtyValue) {
      qtyValue.textContent = safeQty > 0 ? safeQty : 1;
    }

    if (safeQty > 0) {
      atcButton.hidden = true;
      if (qtyUi) qtyUi.hidden = false;
    } else {
      atcButton.hidden = false;
      if (qtyUi) qtyUi.hidden = true;
    }
  }

  function renderVariantQty(variantId, qty) {
    const targetId = String(variantId);

    document
      .querySelectorAll(".Addtocart_buttonsec, .Addtocart_ba-custom_buttonsec")
      .forEach(container => {
        if (getProductCardVariantId(container) === targetId) {
          renderProductCardQty(container, qty);
        }
      });
  }

  function setVariantLoading(variantId, isLoading) {
    const targetId = String(variantId);
    const state = getVariantState(targetId);
    state.requesting = isLoading;
    state.startedAt = isLoading ? Date.now() : null;

    document
      .querySelectorAll(".Addtocart_buttonsec, .Addtocart_ba-custom_buttonsec")
      .forEach(container => {
        if (getProductCardVariantId(container) !== targetId) return;

        const loader = container.querySelector(".loadersec");
        const atcButton = getProductCardAtcButton(container);
        const buttonText = atcButton?.querySelector(".custom-button-text");
        const qtyUi = ensureProductCardQtyUi(container);
        const qtyMode = state.qty > 0 && qtyUi && !qtyUi.hidden;

        if (qtyMode) {
          // Once the first ATC has succeeded, loader belongs ONLY in the center
          // quantity cell. Minus and plus stay visible.
          if (loader) loader.style.display = "none";
          if (buttonText) buttonText.style.visibility = "visible";
          if (atcButton) atcButton.disabled = false;

          qtyUi.classList.toggle("is-loading", isLoading);
          qtyUi.querySelectorAll("button").forEach(button => {
            button.disabled = isLoading;
          });
        } else {
          // Initial Add to Cart keeps the existing card loader behavior.
          if (loader) loader.style.display = isLoading ? "block" : "none";

          if (atcButton) {
            atcButton.classList.toggle("adding", isLoading);
            atcButton.disabled = isLoading;
          }

          if (buttonText) {
            buttonText.style.visibility = isLoading ? "hidden" : "visible";
          }

          if (qtyUi) {
            qtyUi.classList.remove("is-loading");
            qtyUi.querySelectorAll("button").forEach(button => {
              button.disabled = false;
            });
          }
        }
      });
  }

  function syncProductCardQtySelectors(cart) {
    const cartByVariant = new Map();

    cart.items.forEach(item => {
      const variantId = String(item.variant_id);
      const existing = cartByVariant.get(variantId) || {
        qty: 0,
        primaryItem: null,
      };

      existing.qty += Number(item.quantity) || 0;

      // The same variant can sit on several lines (freebie-selector gift lines,
      // Shopify Buy-X-Get-Y splits). "−" must act on a PAID line, largest first.
      const isFree = line => !!(line.properties && line.properties._freebie);
      const better =
        !existing.primaryItem ||
        (isFree(existing.primaryItem) && !isFree(item)) ||
        (isFree(existing.primaryItem) === isFree(item) &&
          Number(item.quantity) > Number(existing.primaryItem.quantity));
      if (better) {
        existing.primaryItem = item;
      }

      cartByVariant.set(variantId, existing);
    });

    // Keep state for every cart variant, even if its product card is injected later.
    cartByVariant.forEach((entry, variantId) => {
      const state = getVariantState(variantId);
      state.qty = entry.qty;
      state.lineItemKey = entry.primaryItem?.key || null;
      state.lineQty = Number(entry.primaryItem?.quantity) || 0;
    });

    document
      .querySelectorAll(".Addtocart_buttonsec, .Addtocart_ba-custom_buttonsec")
      .forEach(container => {
        const variantId = getProductCardVariantId(container);
        if (!variantId) return;

        const entry = cartByVariant.get(variantId);
        const state = getVariantState(variantId);

        state.qty = entry?.qty || 0;
        state.lineItemKey = entry?.primaryItem?.key || null;
        state.lineQty = Number(entry?.primaryItem?.quantity) || 0;

        renderProductCardQty(container, state.qty);
      });
  }

  function pushCustomAddToCartEvent(lineItem, clickFrom, index) {
    const gtmPrice = lineItem.price / 100;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: "Custom_addtocart",
      ecommerce: {
        page_location:  window.location.href,
        page_title:     document.title,
        click_from:     clickFrom,
        rank:           index,
        ecomm_pagetype: detectPageType(),
        value:          gtmPrice,
        currency:       "INR",
        items: [{
          item_id:       `shopify_IN_${lineItem.product_id}_${lineItem.variant_id}`,
          item_name:     lineItem.title,
          item_brand:    lineItem.vendor,
          item_category: lineItem.product_type,
          price:         gtmPrice,
          quantity:      1,
          item_variant:  lineItem.variant_title,
        }],
      },
    });
  }

  // Background confirmation after an add. Shares the single cart-sync pipeline,
  // so the interceptor's add.js sync and this one become ONE /cart.js request.
  function reconcileCartAfterAdd(variantId) {
    requestCartSync()
      .then(cart => {
        window.justAddedBlacklisted = isVariantBlacklisted(cart, variantId);
        // force: the optimistic UI already touched the DOM, always reconcile.
        applyCart(cart, { force: true });

        if (window.justAddedBlacklisted) {
          setTimeout(() => {
            window.justAddedBlacklisted = false;
            if (cachedCart) applyCart(cachedCart, { force: true });
          }, 2000);
        }
      })
      .catch(err => console.error("cart.js reconcile failed:", err));
  }


  // ─── Sticky tier bar (full reconcile from real cart data) ────────────────────
  let previousTierIndex    = null;
  let stickyBarSuccessTimeout = null;

  function updateStickyCartBarWithTiers(cart, config = window.STICKY_CART_CONFIG) {
    cachedCart = cart;
    window.cachedCart = cart;

    syncProductCardQtySelectors(cart);
    toggleCartBottomVisibility(cart);

    const { subTotal, qty } = getFilteredCartTotalAndQty(cart, config);
    const value = config.tierType === "amount" ? subTotal : qty;

    const unlockEls = document.querySelectorAll(".unlock-offer");

    function setUnlockMsg(msg = "", color = "") {
      unlockEls.forEach(el => { el.style.color = color || ""; el.innerHTML = msg || ""; });
    }

    function handleTierLogic(tierIndex, needed, entryMsg, successMsg) {
      if (blacklistedCount > 0 && window.justAddedBlacklisted) {
        setUnlockMsg("❗ Products not eligible for this offer", "#ff0000");
        stickyBarSuccessTimeout = setTimeout(() => {
          setUnlockMsg(entryMsg.replace(/\{min_amount\}/g, formatINR(needed)).replace(/\{min_qty\}/g, needed));
          previousTierIndex = tierIndex;
          window.justAddedBlacklisted = false;
        }, 2000);
      } else {
        if (previousTierIndex < tierIndex) {
          setUnlockMsg(`<b>${successMsg}</b>`, "#2f7a4c");
          stickyBarSuccessTimeout = setTimeout(() => {
            setUnlockMsg(entryMsg.replace(/\{min_amount\}/g, formatINR(needed)).replace(/\{min_qty\}/g, needed));
            previousTierIndex = tierIndex;
          }, 3000);
        } else {
          setUnlockMsg(entryMsg.replace(/\{min_amount\}/g, formatINR(needed)).replace(/\{min_qty\}/g, needed));
          previousTierIndex = tierIndex;
        }
      }
    }

    document.querySelectorAll(".item-total-layout").forEach(el => {
      el.textContent = formatINR(cart.total_price / 100);
    });

    document.querySelectorAll(".item-count-layout").forEach(el => {
      el.textContent = `${cart.item_count} ${cart.item_count === 1 ? "item" : "items"}`;
    });

    document.querySelectorAll(".CartBottom-SectionMain").forEach(el => {
      el.classList.toggle("active", cart.items.length > 0);
    });

    const bubble    = document.querySelector(".cart-link__bubble")     || document.querySelector(".cart-link-bubble");
    const bubbleNum = document.querySelector(".cart-link__bubble-num") || document.querySelector(".cart-link-bubble-num");
    if (bubble && bubbleNum) {
      bubbleNum.textContent = cart.item_count;
      bubble.classList.toggle("cart-link__bubble--visible", cart.item_count > 0);
    }

    const totalItems    = cart.items.length;
    const filteredItems = filterCartItems(cart, config);
    const eligibleQty   = filteredItems.reduce((acc, item) => acc + item.quantity, 0);
    const blacklistedCount = totalItems - filteredItems.length;

    if (totalItems > 0 && eligibleQty === 0) {
      clearTimeout(stickyBarSuccessTimeout);
      setUnlockMsg("❗ All products in your cart are not eligible for this offer", "#ff0000");
      document.querySelectorAll(".progress-bar-fill").forEach(el => { el.style.width = "0%"; });
      previousTierIndex = null;
      return;
    }

    const tier0max = config.tiers[0]?.max || 0;
    const tier1max = config.tiers[1]?.max || 0;
    const tier2max = config.tiers[2]?.max || 0;
    clearTimeout(stickyBarSuccessTimeout);

    if (value <= tier0max - 1) {
      handleTierLogic(0, tier0max - value, config.tiers[0].entryMsg, "");
    } else if (value > tier0max - 1 && value < tier1max) {
      handleTierLogic(1, tier1max - value, config.tiers[1].entryMsg, config.tiers[0].successMsg);
    } else if (value >= tier1max && value < tier2max) {
      handleTierLogic(2, tier2max - value, config.tiers[2].entryMsg, config.tiers[1].successMsg);
    } else if (value >= tier2max) {
      setUnlockMsg(`<b>${config.tiers[2].successMsg}</b>`, "#2f7a4c");
      previousTierIndex = 3;
    } else {
      setUnlockMsg("");
    }

    let progressPercent = 0;
    if (value <= tier0max - 1) {
      progressPercent = (value / tier0max) * 100;
    } else if (value <= tier1max - 1) {
      progressPercent = ((value - tier0max) / (tier1max - tier0max)) * 100;
    } else if (value <= tier2max - 1) {
      progressPercent = ((value - tier1max) / (tier2max - tier1max)) * 100;
    } else {
      progressPercent = 100;
    }

    progressPercent = Math.min(Math.max(progressPercent, 0), 100);
    document.querySelectorAll(".progress-bar-fill").forEach(el => {
      el.style.width = `${progressPercent}%`;
    });
  }

  // ─── Add to Cart + product-card quantity selector ─────────────────────────────
  //
  // Add / increase use add.js so existing promotion/B1G1 behavior stays intact.
  // Decrease uses the cached Shopify line-item key, matching the PDP quantity flow.
  // Product cards render only − / qty / +; View Cart is intentionally not rendered.

  // Setup only. The click itself is handled by one delegated listener below, so
  // cards injected after load (collection filter/sort re-render, sliders) work
  // without needing to be re-bound.
  function setupAddToCartButtons(selector, root = document) {
    root.querySelectorAll(selector).forEach(button => {
      if (
        button.classList.contains("increase-qty") ||
        button.classList.contains("decrease-qty")
      ) {
        return;
      }

      const container = button.closest(
        ".Addtocart_buttonsec, .Addtocart_ba-custom_buttonsec"
      );
      const variantId = button.dataset.id;

      if (container && variantId) {
        container.dataset.variantId = variantId;
        getProductCardProductId(container);
        ensureProductCardQtyUi(container);

        const state = getVariantState(variantId);
        if (state.qty > 0) {
          renderProductCardQty(container, state.qty);
        }
      }
    });
  }

  // Delegated Add to Cart. The `>` in the selector already excludes the +/−
  // buttons, which live inside .product-card-qty-ui.
  document.addEventListener("click", async function (e) {
    const button = e.target.closest(
      ".Addtocart_buttonsec > button[data-id], " +
      ".Addtocart_ba-custom_buttonsec > button[data-id]"
    );

    if (!button) return;
    if (
      button.classList.contains("increase-qty") ||
      button.classList.contains("decrease-qty")
    ) {
      return;
    }

    e.preventDefault();

    const currentContainer = button.closest(
      ".Addtocart_buttonsec, .Addtocart_ba-custom_buttonsec"
    );
    const currentVariantId = button.dataset.id;
    if (!currentContainer || !currentVariantId) return;

    currentContainer.dataset.variantId = currentVariantId;
    ensureProductCardQtyUi(currentContainer);

    const state = getVariantState(currentVariantId);
    if (state.requesting) return;

    const clickFrom    = button.dataset.click  || "NA";
    const index        = button.dataset.index  || "unknown";
    const productPrice = Number(button.dataset.price) || 0;
    const currentProductId = getProductCardProductId(currentContainer);

    setVariantLoading(currentVariantId, true);

    const reservation = await reserveCartLimit(currentProductId);
    if (!reservation.ok) {
      setVariantLoading(currentVariantId, false);
      CartLimits.notify(reservation.message);
      applyCartLimitUi();
      return;
    }

    try {
      const res = await fetchWithTimeout("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", ...CART_LIMIT_HEADERS },
        body: JSON.stringify({ id: currentVariantId, quantity: 1 }),
      });

      if (!res.ok) {
        throw new Error(
          await readCartError(res, `Please try again in few minutes`)
        );
      }

      const lineItem = await res.json();

      // add.js returns the line-item key, so decrease is ready immediately.
      state.lineItemKey = lineItem.key || state.lineItemKey;
      state.lineQty = Number(lineItem.quantity) || (Number(state.lineQty) || 0) + 1;
      state.qty = Math.max(0, Number(state.qty) || 0) + 1;

      if (CartLimits) {
        CartLimits.registerVariant(currentVariantId, lineItem.product_id);
        CartLimits.commit(currentProductId || lineItem.product_id, 1);
      }

      renderVariantQty(currentVariantId, state.qty);
      setVariantLoading(currentVariantId, false);

      optimisticallyUpdateBubble();
      optimisticallyUpdateStickyBar(productPrice);
      showCartNotification();

      pushCustomAddToCartEvent(lineItem, clickFrom, index);

      // Confirm exact quantity/key, tier state and blacklist in background.
      reconcileCartAfterAdd(currentVariantId);
    } catch (err) {
      setVariantLoading(currentVariantId, false);
      console.error("Add to cart failed:", err);
      showProductCardError(
        err?.name === "AbortError"
          ? "Network is slow right now. Please try again."
          : err?.message || "Could not add to cart. Please try again."
      );
      syncStickyCartFromServer("product-card-atc-error");
    } finally {
      if (CartLimits) CartLimits.release(currentProductId, 1);
    }
  });

  // Event delegation keeps +/− working for every product card and for cards
  // injected after page load by sliders/collection rendering.
  document.addEventListener("click", async function (e) {
    const qtyButton = e.target.closest(
      ".Addtocart_buttonsec .increase-qty, " +
      ".Addtocart_buttonsec .decrease-qty, " +
      ".Addtocart_ba-custom_buttonsec .increase-qty, " +
      ".Addtocart_ba-custom_buttonsec .decrease-qty"
    );

    if (!qtyButton) return;

    e.preventDefault();
    e.stopPropagation();

    const container = qtyButton.closest(
      ".Addtocart_buttonsec, .Addtocart_ba-custom_buttonsec"
    );
    const variantId = getProductCardVariantId(container);
    const atcButton = getProductCardAtcButton(container);

    if (!container || !variantId || !atcButton) return;

    const state = getVariantState(variantId);
    if (state.requesting) return;

    // If a newly injected card has not rendered its state yet, use its visible qty.
    if (!state.qty) {
      const visibleQty = Number(
        container.querySelector("[data-qty-value], .qty")?.textContent
      );
      if (visibleQty > 0 && !container.querySelector(".product-card-qty-ui")?.hidden) {
        state.qty = visibleQty;
      }
    }

    const clickFrom    = atcButton.dataset.click  || "NA";
    const index        = atcButton.dataset.index  || "unknown";
    const productPrice = Number(atcButton.dataset.price) || 0;

    if (qtyButton.classList.contains("increase-qty")) {
      const productId = getProductCardProductId(container);

      setVariantLoading(variantId, true);

      const reservation = await reserveCartLimit(productId);
      if (!reservation.ok) {
        setVariantLoading(variantId, false);
        CartLimits.notify(reservation.message);
        applyCartLimitUi();
        return;
      }

      try {
        const res = await fetchWithTimeout("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", ...CART_LIMIT_HEADERS },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });

        if (!res.ok) {
          throw new Error(await readCartError(res, "increase qty failed"));
        }

        const lineItem = await res.json();

        state.lineItemKey = lineItem.key || state.lineItemKey;
        state.lineQty = Number(lineItem.quantity) || (Number(state.lineQty) || 0) + 1;
        state.qty = Math.max(0, Number(state.qty) || 0) + 1;

        if (CartLimits) {
          CartLimits.registerVariant(variantId, lineItem.product_id);
          CartLimits.commit(productId || lineItem.product_id, 1);
        }

        renderVariantQty(variantId, state.qty);
        setVariantLoading(variantId, false);

        optimisticallyUpdateBubble();
        optimisticallyUpdateStickyBar(productPrice);
        showCartNotification();

        pushCustomAddToCartEvent(lineItem, clickFrom, index);

        // Background confirmation, same pattern as the initial ATC.
        reconcileCartAfterAdd(variantId);
      } catch (err) {
        setVariantLoading(variantId, false);
        console.error("Increase qty failed:", err);
        showProductCardError(
          err?.name === "AbortError"
            ? "Network is slow right now. Please try again."
            : err?.message || "Could not update quantity. Please try again."
        );
        syncStickyCartFromServer("product-card-increase-error");
      } finally {
        if (CartLimits) CartLimits.release(productId, 1);
      }

      return;
    }

    if (qtyButton.classList.contains("decrease-qty")) {
      // lineItemKey is normally populated by initial cart sync or add.js.
      // A fallback sync handles a card injected before its state was reconciled.
      if (!state.lineItemKey) {
        try {
          const cart = await requestCartSync();
          applyCart(cart);
          syncProductCardQtySelectors(cart);
        } catch (err) {
          console.error("Unable to resolve cart line before decrease:", err);
          return;
        }
      }

      if (!state.lineItemKey || state.qty <= 0) return;

      setVariantLoading(variantId, true);

      // change.js SETS the quantity of ONE line. The variant may be spread over
      // several lines (gift lines, Buy-X-Get-Y splits), so lower that line by
      // exactly one — never set it to (variant total − 1), which grows the cart.
      const lineQty = Number(state.lineQty) || Number(state.qty) || 0;
      const newLineQty = Math.max(0, lineQty - 1);

      try {
        // No limit header: cart-limits.js checks this request, so a "decrease"
        // that would ever grow a line past a limit is refused, not trusted.
        const res = await fetchWithTimeout("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: state.lineItemKey,
            quantity: newLineQty,
          }),
        });

        if (!res.ok) {
          throw new Error(await readCartError(res, "decrease qty failed"));
        }

        // change.js returns the complete cart. The fetch interceptor below
        // renders from this same body; applyCart() dedupes so only one render
        // happens, whichever parses first.
        const cart = await res.json();
        applyCart(cart);

        setVariantLoading(variantId, false);
        hideCartNotification();
      } catch (err) {
        setVariantLoading(variantId, false);
        console.error("Decrease qty failed:", err);
        syncStickyCartFromServer("product-card-decrease-error");
      }
    }
  });


  // ─── Sidecart refresh after Shopify cart mutations ───────────────────────────
  // Ping Sidecart once immediately. Send ONE trailing ping only if more
  // mutations arrived during the 250ms window (e.g. a promotion app adding a
  // free gift right after an add) — previously it always pinged twice.
  let sidecartCartUpdateTimer = null;
  let sidecartCartUpdateDirty = false;

  function postSidecartCartUpdate() {
    window.postMessage({
      name: "SRSC_UPDATE_CART",
      body: {}
    }, "*");
  }

  function scheduleSidecartCartUpdate() {
    if (!sidecartCartUpdateTimer) {
      postSidecartCartUpdate();
    } else {
      sidecartCartUpdateDirty = true;
      clearTimeout(sidecartCartUpdateTimer);
    }

    sidecartCartUpdateTimer = setTimeout(() => {
      if (sidecartCartUpdateDirty) postSidecartCartUpdate();
      sidecartCartUpdateDirty = false;
      sidecartCartUpdateTimer = null;
    }, 250);
  }


  // ─── Fetch interceptor ────────────────────────────────────────────────────────
  // Watches cart mutations from other scripts (apps, side cart, drawer, etc.).
  //  • change/update/clear.js → response already IS the full cart: render from a
  //    clone of it (no extra /cart.js). Only ping Sidecart if items changed —
  //    attribute-only writes (Helium _helium_session, Wishlink _wl, CustomFit,
  //    Razorpay rzp_*…) no longer trigger anything.
  //  • add.js → returns only line items, so one debounced /cart.js sync.
  // Other scripts (MoEngage, Helium) also wrap window.fetch, so always clone.
  (function monitorCartRequests() {
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url;
      const isFullCartMutation = !!url && /\/cart\/(change|update|clear)\.js/.test(url);
      const isAdd = !!url && /\/cart\/add\.js/.test(url);

      // Snapshot BEFORE the request so we can tell whether items changed.
      const sigBefore = (isFullCartMutation || isAdd) ? cartSignature(cachedCart) : null;

      const response = await originalFetch.apply(this, args);
      if (!response.ok) return response;

      if (isFullCartMutation) {
        response
          .clone()
          .json()
          .then(cart => {
            const sigAfter = cartSignature(cart);
            applyCart(cart);
            // Unknown baseline (cart not loaded yet) → ping to stay correct.
            if (sigBefore === null || sigAfter !== sigBefore) {
              scheduleSidecartCartUpdate();
            }
          })
          .catch(() => {
            // Body wasn't a cart (unexpected) → fall back to one shared sync.
            requestCartSync()
              .then(cart => {
                applyCart(cart);
                scheduleSidecartCartUpdate();
              })
              .catch(err => console.error("cart sync after mutation failed:", err));
          });
      } else if (isAdd) {
        scheduleSidecartCartUpdate();
        // Our own ATC/increase already calls reconcileCartAfterAdd().
        if (args[1] && args[1].__innovistOwn) return response;
        requestCartSync()
          .then(cart => applyCart(cart))
          .catch(err => console.error("cart sync after add failed:", err));
      }

      return response;
    };
  })();

  // ─── Cart sync entry point (initial load, errors, visibility, bfcache) ────────
  function syncStickyCartFromServer(reason = "manual", { force = false } = {}) {
    return requestCartSync()
      .then(cart => applyCart(cart, { force }))
      .catch(err => console.error(`Sticky cart sync failed: ${reason}`, err));
  }

  syncStickyCartFromServer("initial-load", { force: true });

  // ─── iOS Safari back/forward cache fix ────────────────────────────────────────
  window.addEventListener("pageshow", function (event) {
    const navEntry = performance.getEntriesByType("navigation")[0];
    const isBackForward =
      event.persisted ||
      navEntry?.type === "back_forward";

    if (isBackForward) {
      window.sidecartDiscountDetails = null;
      // bfcache preserves JS memory, so a card interrupted mid-request comes
      // back still spinning and disabled. Reset it before syncing.
      clearStaleProductCardLoading(0);
      syncStickyCartFromServer("pageshow-back-forward", { force: true });
    }
  });

  // ─── Extra safety for iOS Safari page restore ─────────────────────────────────
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") {
      clearStaleProductCardLoading();
      syncStickyCartFromServer("visibilitychange-visible");
    }
  });

  function initProductCardCart(root = document) {
    setupAddToCartButtons(
      ".Addtocart_buttonsec > button[data-id]",
      root
    );
    setupAddToCartButtons(
      ".Addtocart_ba-custom_buttonsec > button[data-id]",
      root
    );
    applyCartLimitUi();
  }

  // Make the same ATC + quantity-selector flow available to sections whose
  // product cards are fetched and inserted after DOMContentLoaded.
  window.initProductCardCart = initProductCardCart;

  initProductCardCart();

  // The collection grid replaces #AjaxContent innerHTML on every filter, sort,
  // tag, price-range and back-button action. Re-run setup so the fresh cards
  // pick up their variant state and quantity UI.
  document.addEventListener("collection:reloaded", function () {
    initProductCardCart();
    if (cachedCart) {
      syncProductCardQtySelectors(cachedCart);
    } else {
      syncStickyCartFromServer("collection-reloaded");
    }
  });

  // ─── Shared cart API for other blocks ─────────────────────────────────────────
  //   InnovistCart.subscribe(fn) → fn(cart) now (if known) and on every change
  //   InnovistCart.current()     → last known cart (or null)
  //   InnovistCart.refresh()     → shared, debounced /cart.js read
  window.InnovistCart = {
    subscribe(fn) {
      cartSubscribers.push(fn);
      if (cachedCart) {
        try { fn(cachedCart); } catch (err) { console.error("cart subscriber failed:", err); }
      }
      return () => {
        const i = cartSubscribers.indexOf(fn);
        if (i > -1) cartSubscribers.splice(i, 1);
      };
    },
    current() {
      return cachedCart;
    },
    refresh() {
      return requestCartSync().then(cart => {
        applyCart(cart);
        return cart;
      });
    },
  };

  document.dispatchEvent(new CustomEvent("product-card-cart:ready"));
  document.dispatchEvent(new CustomEvent("innovist-cart:ready"));

  function applySidecartDiscountTotals() {
    if (!window.sidecartDiscountDetails) return;

    const details = window.sidecartDiscountDetails;
    const toPayAmount = Number(details.to_pay_amount);

    // Shiprocket's to_pay_amount is the authoritative displayed payable amount.
    // Use it immediately for both discount apply and remove events when available.
    if (Number.isFinite(toPayAmount)) {
      document.querySelectorAll(".item-total-layout").forEach(el => {
        el.textContent = formatINR(toPayAmount);
      });
      return;
    }

    if (details.status === "removed" && cachedCart) {
      document.querySelectorAll(".item-total-layout").forEach(el => {
        el.textContent = formatINR(cachedCart.total_price / 100);
      });
    }
  }

  // ─── postMessage events (quantity change, add/remove, discount apply/remove) ──
  // Listens to Sidecart events and refreshes cart details without changing ATC flow.
  // Sidecart runs in an iframe, so its own cart edits don't pass through our
  // fetch interceptor — we still need a /cart.js read here, but bursts of
  // events now share ONE debounced read instead of one read per event.
  window.addEventListener("message", function (event) {
    if (!event.data || !event.data.name) return;

    const eventName = event.data.name;
    const eventBody = event.data.body || {};

    switch (eventName) {
      case "quantity_change":
      case "item_added":
      case "item_removed":
      case "cart_update":
      case "discount_application":
      case "discount_removed": {

        // Store latest sidecart event details separately for reference/debug/GTM if needed.
        window.latestSidecartEvent = {
          name: eventName,
          body: eventBody,
        };

        const isDiscountEvent =
          eventName === "discount_application" ||
          eventName === "discount_removed";

        const hasSidecartPricing =
          eventBody.to_pay_amount !== undefined &&
          Number.isFinite(Number(eventBody.to_pay_amount));

        // Store Sidecart pricing whenever the event carries it.
        // Some quantity/cart events can also include the latest payable amount.
        if (isDiscountEvent || hasSidecartPricing) {
          window.sidecartDiscountDetails = {
            discount: Number(eventBody.discount) || 0,
            cart_total: Number(eventBody.cart_total) || 0,
            to_pay_amount: Number(eventBody.to_pay_amount),
            status:
              eventName === "discount_removed" || Number(eventBody.discount) <= 0
                ? "removed"
                : "applied",
          };

          // Do not wait for cart.js before reflecting Shiprocket's actual payable total.
          if (hasSidecartPricing) {
            applySidecartDiscountTotals();
          }
        }

        // Latest Shopify cart for item count, quantity, line keys, product-card
        // selector state and the normal cart total (shared, debounced read).
        requestCartSync()
          .then(cart => {
            applyCart(cart);

            // A re-render writes Shopify's raw total. Reapply the latest
            // Sidecart payable value (no-op if nothing was re-rendered).
            if (
              isDiscountEvent ||
              hasSidecartPricing ||
              hasActiveSidecartDiscount()
            ) {
              applySidecartDiscountTotals();
            }
          })
          .catch(err => console.error("Sidecart cart sync failed:", err));

        break;
      }
    }
  });

}); // end DOMContentLoaded


// ─── View Cart GTM event ──────────────────────────────────────────────────────
// Uses cachedCart so no extra /cart.js fetch on button click.
// Falls back to a fresh fetch only on cold page load (before any ATC happened).
function pushViewCartEvent(clickFrom, cart) {
  if (!cart) {
    fetch('/cart.js')
      .then(res => res.json())
      .then(freshCart => pushViewCartEvent(clickFrom, freshCart))
      .catch(err => console.error('Cart fetch error:', err));
    return;
  }

  const productData = cart.items.map(product => ({
    price:            product.price / 100,
    compare_at_price: product.compare_at_price !== undefined
      ? product.compare_at_price / 100
      : product.price / 100,
    vendor:     product.vendor,
    variant_id: product.id,
    product_id: product.product_id,
    url:        product.url,
    handle:     product.handle,
    title:      product.title,
    quantity:   product.quantity,
  }));

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event:                'view_cart',
    original_total_price: cart.original_total_price / 100,
    items_subtotal_price: cart.items_subtotal_price / 100,
    item_count:           cart.item_count,
    product_data:         productData,
    click_from:           clickFrom,
  });
}


// ─── View Cart button click ───────────────────────────────────────────────────
document.addEventListener('click', function (e) {
  const target = e.target.closest(
    '.CartBottom-SectionMain .buy-now-button, .mainbutton_addtocart .view-cart-btn'
  );
  if (!target) return;

  e.preventDefault();

   if (typeof window.slideShiprocketSmartCartInFrame === "function") {
        window.slideShiprocketSmartCartInFrame();
          }

  if (typeof pushViewCartEvent === 'function') {
    pushViewCartEvent('view_cart_btn', window.cachedCart || null);
  }
});